import {useParams} from "react-router";
import {useQuery} from "@tanstack/react-query";
import AgentInfoService from "../../../services/reports/agent-info-service.js";
import {Template} from "../../../components/template/template.jsx";
import Content from "./components/content.jsx";
import {useRef, useState} from "react";
import HeaderButtons from "../../../components/reports/report-menu/header-buttons.jsx";
import {Card} from "../../../components/card/card.jsx";
import PrintOptionsModal from "../../../components/print-options-modal/print-options-modal.jsx";

const userModules = [
    { key: "documents", permission: "sentry.user.documents"},
    { key: "trainings", permission: "sentry.user.trainings"},
    { key: "conductHistory", permission: "sentry.user.conduct_history"},
    { key: "privateWeapons", permission: "sentry.user.private_weapons"},
    { key: "dayOff", permission: "sentry.user.absences"},
    { key: "clothes", permission: "sentry.user.clothes"},
    { key: "dependents", permission: "sentry.user.dependents"},
    { key: "skillsRestrictions", permission: "sentry.user.skills_restrictions"},
];

const printFields = [
    { key: "address", label: "Endereço" },
    { key: "phones", label: "Telefones" },
    { key: "documents", label: "Documentos", permission: "sentry.user.documents" },
    { key: "trainings", label: "Formações e aperfeiçoamento", permission: "sentry.user.trainings" },
    { key: "conductHistory", label: "Histórico de conduta", permission: "sentry.user.conduct_history" },
    { key: "privateWeapons", label: "Armas particulares", permission: "sentry.user.private_weapons" },
    { key: "dayOff", label: "Ausências", permission: "sentry.user.absences" },
    { key: "clothes", label: "Vestuário", permission: "sentry.user.clothes" },
    { key: "dependents", label: "Dependentes", permission: "sentry.user.dependents" },
    { key: "skillsRestrictions", label: "Aptidões e restrições", permission: "sentry.user.skills_restrictions" },
];

const initialPrintOptions = Object.fromEntries(printFields.map((item) => [item.key, true]));

export default function AgentInfo() {
    const { id } = useParams();
    const [headerSelected, setHeaderSelected] = useState(-1);
    const [isPrinting, setIsPrinting] = useState(false);
    const [printModal, setPrintModal] = useState(false);
    const [printOptions, setPrintOptions] = useState(initialPrintOptions);
    const printComponentRef = useRef(null);
    const title = "Informações do agente";

    const { data: reportUser, isLoading: isLoadingReport } = useQuery({
        queryKey: ["report-user", id],
        queryFn: () => AgentInfoService.getUser(id),
        enabled: !!id,
    });

    const { data: loggedInfo, isLoading: isLoadingPermissions } = useQuery({
        queryKey: ["logged-user-info"],
        queryFn: () => AgentInfoService.getInfo(),
    });

    const permissions = loggedInfo?.userLoggedPermissions ?? [];

    const visibleModules = userModules.filter(module => permissions.includes(module.permission));

    const visibleModulesMap = Object.fromEntries(visibleModules.map((module) => [module.key, true]));

    const allowedPrintFields = printFields.filter((item) => {
        if (!item.permission) return true;
        return permissions.includes(item.permission);
    });

    const printItems = [
        {
            title: "",
            options: allowedPrintFields,
        }
    ];

    const hasData = !!reportUser?.id;

    return (
        <>
            <Template isLoading={isLoadingReport || isLoadingPermissions || isPrinting}>
                <Template.Header>
                    <Template.Title>{title}</Template.Title>
                    <HeaderButtons
                        printOptions={true}
                        setPrintModal={setPrintModal}
                        printable={true}
                        headerChange={true}
                        printComponentRef={printComponentRef}
                        reportData={reportUser}
                        data={hasData}
                        headerSelected={headerSelected}
                        setHeaderSelected={setHeaderSelected}
                    />
                </Template.Header>
                <Template.Body className="pl-0!">
                    <Card className="w-full max-w-[1030px] mx-auto p-[0]!">
                        <Card.Body>
                            <Content
                                reportData={reportUser}
                                data={hasData}
                                entity={headerSelected}
                                title={title}
                                printComponentRef={printComponentRef}
                                setIsPrinting={setIsPrinting}
                                visibleModules={visibleModulesMap}
                                printOptions={printOptions}
                            />
                        </Card.Body>
                    </Card>
                </Template.Body>
            </Template>

            <PrintOptionsModal
                open={printModal}
                setOpen={setPrintModal}
                printRef={printComponentRef}
                options={printOptions}
                setOptions={setPrintOptions}
                items={printItems}
            />
        </>
    )
}